import { cn } from "@/lib/utils";
import {
  Archive,
  CheckSquare,
  Inbox,
  Settings,
  Users,
  ClipboardPen,
  Briefcase,
  LucideIcon
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/features/auth/context/AuthContext";
type NavBarItem = {
  title?: string;
  translationKey?: string;
  href: string;
  icon: LucideIcon;
  comingSoon?: boolean;
};
const employerItems: NavBarItem[] = [
  {
    title: "Posteingang",
    href: "/inbox",
    icon: Inbox,
    comingSoon: true
  },
  {
    title: "Bewerbungen",
    href: "/applications",
    icon: ClipboardPen,
    comingSoon: false
  },
  {
    title: "Bewerber",
    href: "/applicants",
    icon: Users,
    comingSoon: false
  },
  {
    title: "Meine Jobs",
    href: "/myjobs",
    icon: Briefcase,
    comingSoon: false
  },
  {
    title: "Aufgaben",
    href: "/tasks",
    icon: CheckSquare,
    comingSoon: true
  },
  {
    title: "Archiv",
    href: "/archive",
    icon: Archive,
    comingSoon: true
  }
];

const partnerItems = [
  {
    title: "Bewerbungen",
    href: "/applications",
    icon: ClipboardPen,
    comingSoon: false
  },
  {
    title: "Bewerber",
    href: "/applicants",
    icon: Users,
    comingSoon: false
  }
];
export function Sidebar() {
  const location = useLocation();
  const { t: translation } = useTranslation(["common", "partner", "admin"]);
  const { profile } = useAuth();

  const items = profile.role === "partner" ? partnerItems : employerItems;
  const getItemTranslatedString = (translationKey: string) => {
    return translation(`${profile.role}:sidebar.${translationKey}`);
  };
  return (
    <div className="w-16 bg-gray-100 border-r flex flex-col items-center">
      <div className="p-4 w-full flex justify-center">
        <Link to="/applications">
          <div className="h-8 w-8 rounded-md bg-[#d769b3] flex items-center justify-center text-[#471999] font-bold">
            <strong>W</strong>
          </div>
        </Link>
      </div>
      <div className="flex flex-col items-center gap-6 py-6 flex-1">
        {items.map((item: NavBarItem) => {
          const Icon = item.icon;
          if (item.comingSoon) {
            return (
              <div
                key={item.href}
                className="group relative p-2 text-gray-300 cursor-not-allowed"
              >
                <Icon size={20} />
                <div
                  className="absolute left-full ml-2 px-2 py-1 bg-gray-900 text-white text-xs rounded 
                                    invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-opacity whitespace-nowrap"
                >
                  {item.translationKey
                    ? getItemTranslatedString(item.translationKey)
                    : item.title}
                </div>
              </div>
            );
          }
          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                "p-2 text-gray-500 hover:bg-gray-200 hover:text-gray-900 rounded-md",
                location.pathname.startsWith(item.href) &&
                  "bg-gray-200 text-gray-900"
              )}
            >
              <Icon size={20} />
            </Link>
          );
        })}
      </div>
      <div className="p-4 w-full flex justify-center">
        <Link
          to="/settings"
          className={cn(
            "p-2 text-gray-500 hover:bg-gray-200 hover:text-gray-900 rounded-md inline-flex",
            location.pathname.startsWith("/settings") &&
              "bg-gray-200 text-gray-900"
          )}
        >
          <Settings size={20} />
        </Link>
      </div>
    </div>
  );
}
